<lib-ikp-top-page
  [title]="'global.registration.agent-selection.title'"
  [showGoBackLink]="false"
  [dataTest]="'accountRegistration-header-agentSelectionTopPageTitle'"
/>
<div class="profile-creation">
  <mwe-basic-card cardTitle="global.registration.agent-selection.cardTitle" cardClass="ikp-basic-card-override" [hasBackground]="true">
    <div>
      <p>
        Der gewählte Kontakt, wird den Nutzer*innen dieses Accounts mit Name, E-Mail Adresse und Telefonnummer auf der Startseite angezeigt.
      </p>
      @if (berater()?.length > 1) {
        <lib-ikp-dropdown
          inputId="kundenRegistrierung-agentSelection"
          labelKey="Wählen Sie einen Berater"
          dropdownToggleType="input"
          withDefaultOption="selected"
          [ngModel]="selectedBerater()"
          (ngModelChange)="selectedBerater.set($event.value)"
          [options]="berater() | beraterDropdownOption: 'BeraterArray'"
          [dataTestAttribute]="{ page: 'kundenRegistrierung', scope: 'AgentSelection' }"
          (focusin)="registrationService.isNextButtonDisabled.set(true)"
          (focusout)="registrationService.isNextButtonDisabled.set(false)"
        />
      } @else {
        <div class="pl-2">
          <p class="my-0">Zuständiger Berater</p>
          <strong>{{ berater()?.[0]?.firstName }} {{ berater()?.[0]?.lastName }}</strong>
        </div>
      }
    </div>
  </mwe-basic-card>
</div>
